// B-108 — the day's detail moves to the day before and the day after without going back to the
// list: ◀ dd-mm-aaaa ▶ beside the breadcrumb. It moves among the dates the client has closings on
// (`getCierreClosingDates`, 40 days each side, one request), so a weekend or a day nobody worked is
// never landed on; an arrow with nothing on its side is disabled. The page changes `?fecha=`, so the
// browser's back button walks the days back too.
import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@mantis-sas/ui";

import { getCierreClosingDates } from "../../../ApiCalls/mantisBusiness";
import { fechaDMY, restarDias } from "../../../utils/cierrePanel";
import { fechasVecinas } from "../../../utils/cierreCuadreDia";
import { guia } from "../../../utils/cierreTours";

const VENTANA_DIAS = 40;
const FLECHA = "grid h-7 w-7 place-items-center rounded-[6px] border bg-card text-brinks-foreground transition hover:bg-brinks-surface-hover "
  + "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-40";

export function NavegadorDeDias({
  token, mantisBusinessId, clientCode, fecha, onCambiarFecha,
}) {
  const [vecinas, setVecinas] = useState({ anterior: null, siguiente: null });

  useEffect(() => {
    let activo = true;
    setVecinas({ anterior: null, siguiente: null });
    if (!clientCode || !fecha) return undefined;
    getCierreClosingDates(token, mantisBusinessId, clientCode, {
      since: restarDias(fecha, VENTANA_DIAS), until: restarDias(fecha, -VENTANA_DIAS), limit: 100,
    })
      .then((r) => {
        if (!activo || !r?.success) return;
        setVecinas(fechasVecinas((r.data?.dates || []).map((d) => d.businessDate), fecha));
      })
      .catch(() => {});
    return () => {
      activo = false;
    };
  }, [token, mantisBusinessId, clientCode, fecha]);

  return (
    <span {...guia("Cambiar de día", "Pasa al día anterior o al siguiente con cierres, sin volver a la lista.")} className="inline-flex items-center gap-1.5" role="group" aria-label="Cambiar de día">
      <button
        type="button"
        className={FLECHA}
        disabled={!vecinas.anterior}
        onClick={() => onCambiarFecha(vecinas.anterior)}
        aria-label={vecinas.anterior ? `Día anterior, ${fechaDMY(vecinas.anterior)}` : "Día anterior"}
        title={vecinas.anterior ? fechaDMY(vecinas.anterior) : "No hay un día anterior con cierres"}
      >
        <ChevronLeft className="h-4 w-4" />
      </button>
      <span className={cn("min-w-[82px] text-center font-semibold tabular-nums text-brinks-foreground")}>{fechaDMY(fecha)}</span>
      <button
        type="button"
        className={FLECHA}
        disabled={!vecinas.siguiente}
        onClick={() => onCambiarFecha(vecinas.siguiente)}
        aria-label={vecinas.siguiente ? `Día siguiente, ${fechaDMY(vecinas.siguiente)}` : "Día siguiente"}
        title={vecinas.siguiente ? fechaDMY(vecinas.siguiente) : "No hay un día siguiente con cierres"}
      >
        <ChevronRight className="h-4 w-4" />
      </button>
    </span>
  );
}

export default NavegadorDeDias;
